import { z } from 'zod'

export const MAX_HOME_CAROUSEL_SLIDES = 5

export const createHomeCarouselSlideSchema = z.object({
  image_url: z.string().url(),
  alt_text: z.string().max(200).optional(),
  display_order: z
    .number()
    .int()
    .min(1)
    .max(MAX_HOME_CAROUSEL_SLIDES)
    .optional(),
  is_active: z.boolean().optional(),
})

export const updateHomeCarouselSlideSchema =
  createHomeCarouselSlideSchema.partial()

export const reorderHomeCarouselSlidesSchema = z.object({
  items: z
    .array(
      z.object({
        id: z.string().min(1),
        display_order: z.number().int().min(1).max(MAX_HOME_CAROUSEL_SLIDES),
      }),
    )
    .min(1)
    .max(MAX_HOME_CAROUSEL_SLIDES),
})

export type CreateHomeCarouselSlideInput = z.infer<
  typeof createHomeCarouselSlideSchema
>
export type UpdateHomeCarouselSlideInput = z.infer<
  typeof updateHomeCarouselSlideSchema
>
export type ReorderHomeCarouselSlidesInput = z.infer<
  typeof reorderHomeCarouselSlidesSchema
>

export type HomeCarouselSlideResponse = {
  id: string
  image_url: string
  alt_text: string | null
  display_order: number
  is_active: boolean
  created_at: string
  updated_at: string
}
